import api from "../../instance/api";

// Documents the client shared with this appointment; payload is unwrapped from ApplicationResponse.
export const getSharedDocuments = async (appointmentId) => {
  const res = await api.get(`appointment/${appointmentId}/documents`);
  return res.data?.payload || [];
};

// Share history for many appointments at once: { [appointmentId]: SharedDocument[] }.
export const getSharedDocumentsHistory = async (appointmentIds) => {
  const res = await api.post("appointment/documents/history", { appointmentIds });
  return res.data?.payload || {};
};

// Raw file bytes for in-app viewing only; never exposes a storage URL.
export const getSharedDocumentContent = async (appointmentId, documentId) => {
  const res = await api.get(
    `appointment/${appointmentId}/documents/${documentId}/content`,
    { responseType: "blob", headers: { Accept: "*/*" } }
  );
  return res.data;
};

// Pulls the backend message out of an error, including blob-typed error bodies.
export const getSharedDocumentsErrorMessage = async (error) => {
  let data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      data = JSON.parse(await data.text());
    } catch (e) {
      data = null;
    }
  }
  return data?.errorResponse?.errorMessage || data?.response_message || null;
};
